import { SprayBottleIcon } from './SprayBottleIcon';

/**
 * author: Michael Irigoyen
 * id 997059BA-96F4-456C-8B53-8355521AE536
 * name spray-bottle
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/spray-bottle.svg
 * tags
 */
export const CleaningIcon = SprayBottleIcon;
export default CleaningIcon